import { render } from "./kitchenModel.vue?vue&type=template&id=9c4a55f8"
import script from "./kitchenModel.vue?vue&type=script&lang=js"
export * from "./kitchenModel.vue?vue&type=script&lang=js"

import "./kitchenModel.vue?vue&type=style&index=0&id=9c4a55f8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__